import { defineComponent as T, ref as K, watch as $, computed as s, openBlock as f, createElementBlock as m, createElementVNode as p, normalizeClass as d, createCommentVNode as v, toDisplayString as k, withModifiers as D, createVNode as z } from "vue";
import B from "./index60.js";
const O = { class: "flex w-full flex-col" }, P = { class: "flex h-[34px] w-full items-center" }, R = ["value", "placeholder", "disabled"], H = {
  key: 0,
  class: "text-input-border-error mt-1 text-[12px] font-medium"
}, J = /* @__PURE__ */ T({
  __name: "BaseInputStepper",
  props: {
    modelValue: { default: void 0 },
    placeholder: { default: "" },
    size: { default: "sm" },
    disabled: { type: Boolean, default: !1 },
    min: { default: void 0 },
    max: { default: void 0 },
    step: { default: 1e-5 },
    variant: { default: "default" },
    unitLabel: { default: "Lot" },
    error: { type: Boolean, default: !1 },
    errorMessage: { default: "" }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(r, { emit: C }) {
    const a = r, u = C, o = K(a.modelValue ?? 0);
    $(
      () => a.modelValue,
      (e) => {
        e !== void 0 && Number.isFinite(e) ? o.value = e : e === void 0 && (o.value = 0);
      },
      { immediate: !0 }
    );
    const b = s(() => a.size === "sm" ? "sm" : "md"), x = s(() => !(a.disabled || a.min !== void 0 && o.value - a.step < a.min)), g = s(() => !(a.disabled || a.max !== void 0 && o.value + a.step > a.max)), F = (e) => {
      const t = e.target, l = t.value;
      let n = l.replace(/[^0-9.-]/g, "");
      if (n.indexOf("-") > 0 && (n = n.replace(/-/g, "")), (n.match(/\./g) || []).length > 1) {
        const M = n.indexOf(".");
        n = n.substring(0, M + 1) + n.substring(M + 1).replace(/\./g, "");
      }
      if (l !== n && (t.value = n), n === "" || n === "-") {
        o.value = 0;
        return;
      }
      const V = parseFloat(n);
      if (!Number.isFinite(V))
        return;
      const w = c(V);
      o.value = w, u("update:modelValue", w);
    }, c = (e) => {
      let t = e;
      return a.min !== void 0 && (t = Math.max(t, a.min)), a.max !== void 0 && (t = Math.min(t, a.max)), t;
    }, y = (e) => Math.round(e * 1e10) / 1e10, N = (e) => {
      if (e && (e.preventDefault(), e.stopPropagation()), !x.value) return;
      const t = y(o.value - a.step), l = c(t);
      o.value = l, u("update:modelValue", l);
    }, E = (e) => {
      if (e && (e.preventDefault(), e.stopPropagation()), !g.value) return;
      const t = y(o.value + a.step), l = c(t);
      o.value = l, u("update:modelValue", l);
    }, I = (e) => {
      u("focus", e);
    }, S = (e) => {
      h(), u("blur", e);
    }, h = () => {
      const e = c(o.value);
      e !== o.value && (o.value = e, u("update:modelValue", e));
    }, j = (e) => {
      const t = e.key, l = e.target.value, n = [
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ];
      if (t === "Enter") {
        e.preventDefault(), setTimeout(() => {
          h(), e.target.blur();
        }, 0);
        return;
      }
      n.includes(t) || /^[0-9]$/.test(t) || t === "." && !l.includes(".") || t === "-" && !l.includes("-") && e.target.selectionStart === 0 || e.preventDefault();
    }, A = (e) => {
      if (!Number.isFinite(e))
        return "";
      const t = Math.round(e);
      return Math.abs(e - t) < 1e-10 ? t.toString() : e.toFixed(10).replace(/\.?0+$/, "");
    }, L = s(() => A(o.value)), i = s(() => a.error ? "border-input-border-error" : "border-input-border-static");
    return (e, t) => (f(), m("div", O, [
      p("div", P, [
        r.variant === "range" ? (f(), m("div", {
          key: 0,
          class: d(["bg-input-surface flex select-none items-center justify-center rounded-l-[6px] border border-r-0 py-2 pl-3 text-[14px] font-normal leading-[18px]", [
            i.value,
            {
              "cursor-not-allowed opacity-50": r.disabled
            }
          ]])
        }, " ~ ", 2)) : v("", !0),
        p("input", {
          type: "text",
          inputmode: "decimal",
          class: d(["bg-input-surface min-w-0 flex-1 border px-3 py-2 text-[14px] font-normal leading-[18px] focus:outline-none focus:ring-0", [
            i.value,
            {
              "cursor-not-allowed opacity-50": r.disabled,
              "rounded-l-[6px] border-r-0": r.variant === "default" || r.variant === "unit",
              "border-r-0": r.variant === "range" || r.variant === "unit",
              "border-l-0": r.variant === "range",
              "focus:border-input-border-static": !r.error,
              "focus:border-input-border-error": r.error
            }
          ]]),
          value: L.value,
          placeholder: r.placeholder,
          disabled: r.disabled,
          onInput: F,
          onKeydown: j,
          onFocus: I,
          onBlur: S
        }, null, 42, R),
        r.variant === "unit" ? (f(), m("div", {
          key: 1,
          class: d(["bg-input-surface flex select-none items-center justify-center border border-l-0 border-r-0 px-3 py-2 text-[14px] font-normal leading-[18px]", i.value])
        }, k(r.unitLabel), 3)) : v("", !0),
        p("div", {
          class: d(["bg-input-surface flex cursor-pointer items-center justify-center border px-1 py-[9px] transition-colors hover:bg-gray-50", [
            i.value,
            {
              "cursor-not-allowed opacity-50": !g.value
            }
          ]]),
          onMousedown: E,
          onClick: t[0] || (t[0] = D(() => {
          }, ["prevent", "stop"]))
        }, [
          z(B, {
            name: "plus",
            size: b.value
          }, null, 8, ["size"])
        ], 34),
        p("div", {
          class: d(["bg-input-surface flex cursor-pointer items-center justify-center rounded-r-[6px] border border-l-0 px-1 py-[9px] transition-colors hover:bg-gray-50", [i.value, { "cursor-not-allowed opacity-50": !x.value }]]),
          onMousedown: N,
          onClick: t[1] || (t[1] = D(() => {
          }, ["prevent", "stop"]))
        }, [
          z(B, {
            name: "minus",
            size: b.value
          }, null, 8, ["size"])
        ], 34)
      ]),
      r.error && r.errorMessage ? (f(), m("div", H, k(r.errorMessage), 1)) : v("", !0)
    ]));
  }
});
export {
  J as default
};
